import { Roles } from 'types/datatypes/IUser';

export const matchRole = (roles: Roles = [], requiredRoles: Roles = []): boolean => (
  requiredRoles && requiredRoles.length ? roles?.some((role) => requiredRoles.includes(role)) : true
);
